import { addStyles } from 'ethcss'
import { color, IStyles, mediaCSS } from 'theme'

const templateEditorToolbarStyles: IStyles = {
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px 8px',
        flexWrap: 'wrap',
        padding: '8px 12px',
        background: color.bgWhitePrimary,
        borderBottom: `1px solid ${color.borderDarkPrimary}`,
        flexShrink: 0,
        minWidth: 0,

        [mediaCSS.desktopL]: {
            flexWrap: 'nowrap',
        },
    },
    cluster: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        paddingRight: 10,
        marginRight: 2,
        borderRight: `1px solid ${color.bgWhiteTertiary}`,
        minWidth: 0,
        flexShrink: 0,
    },
    clusterBrand: {
        flex: '0 0 auto',
        minWidth: 0,
        borderRight: `1px solid ${color.bgWhiteTertiary}`,
        paddingRight: 10,
        marginRight: 2,
    },
    clusterActions: {
        borderRight: 'none',
        marginLeft: 'auto',
        paddingRight: 0,
        flexWrap: 'wrap',
        justifyContent: 'flex-end',

        [mediaCSS.desktopL]: {
            flex: '1 1 100%',
            marginLeft: 0,
            paddingTop: 6,
            borderTop: `1px solid ${color.bgWhiteTertiary}`,
        },
    },
    titleInput: {
        width: 160,
        maxWidth: 160,
    },
    tools: {
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        flexWrap: 'nowrap',
    },
    toolButtonWrap: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        position: 'relative',
    },
    toolbarIcon: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 36,
        height: 36,
        flexShrink: 0,
        lineHeight: 0,
    },
    toolButtonActive: {
        background: color.blue100,
        boxShadow: `inset 0 0 0 1px ${color.blue}`,

        '&:hover': {
            background: color.blue100,
            borderColor: color.blue,
        },
    },
    shapeMenu: {
        position: 'absolute',
        top: 'calc(100% + 8px)',
        left: 0,
        zIndex: 20,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 8,
        padding: 10,
        width: 248,
        background: color.bgWhitePrimary,
        border: `1px solid ${color.borderDarkPrimary}`,
        borderRadius: 12,
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
    },
    shapeMenuItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        minHeight: 88,
        padding: '12px 8px',
        border: 'none',
        borderRadius: 10,
        background: color.bgWhiteSecondary,
        color: color.fontDarkUltraHigh,
        cursor: 'pointer',
        fontSize: 12,
        lineHeight: 1.2,
        textAlign: 'center',

        '&:hover': {
            background: color.blue100,
        },
    },
    shapeMenuItemActive: {
        background: color.blue100,
        boxShadow: `inset 0 0 0 1px ${color.blue}`,
    },
    toolbarPlacing: {
        boxShadow: `inset 0 -2px 0 ${color.blue}`,
    },
    select: {
        minWidth: 108,
    },
    zoomSelect: {
        minWidth: 136,
    },
}

addStyles(templateEditorToolbarStyles)
export default templateEditorToolbarStyles
